'use strict';

class FlowBox {

    constructor() {

        this.flowboxButtons = document.querySelectorAll('[data-flowbox-button]');
        this.flowboxSelect = document.querySelector('[data-flowbox-select]');
        this.tags = [];

        if (this.flowboxButtons.length > 0) {

            for (let button of this.flowboxButtons) {

                //  Skip the ones with an empty tag (at least the default/first one)
                if (button.dataset.tag !== '') {

                    this.tags.push(`${button.dataset.tag}`);
                }

                button.addEventListener('click', (event) => {

                    event.preventDefault();

                    this.updateFlow(button.dataset.tag);
                    this.clearButtonClasses();

                    button.classList.add('active');
                });
            }

            this.initFlow(this.tags);
        }

        //  Adds support for <select> element (for Mobile)
        if (this.flowboxSelect) {

            this.flowboxSelect.addEventListener('change', (event) => {

                let tag = event.currentTarget.value;

                this.updateFlow(tag);
                this.clearButtonClasses();
            });
        }
    }

    /**
     * Init the FlowBox
     * @param tags
     */
    initFlow(tags) {

        let flowBoxSettings = {
            container: '#flowbox',
            key: rk_globals.flowbox_api
        };

        if (tags.length > 0) {

            flowBoxSettings.tags = tags;
        }

        window.flowbox('init', flowBoxSettings);
    }

    /**
     * Updates the FlowBox by Tag
     * @param tag
     */
    updateFlow(tag) {

        window.flowbox('update', {
            container: '#flowbox',
            key: rk_globals.flowbox_api,
            tags: (tag ? [tag] : this.tags)
        });
    }

    /**
     * Remove 'active' class from all buttons
     */
    clearButtonClasses() {

        for (let button of this.flowboxButtons) {

            button.classList.remove('active')
        }
    }
}

module.exports = FlowBox;
